import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate, laneLabel } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

export default function PartnerReferrals() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/portal/referrals"); setItems(data.items || []); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-[#252221] mb-1">Referrals</h2>
      <p className="text-sm text-muted-foreground mb-5">Families MovingMyMama has referred to you.</p>
      <Card className="border-[#E6EDF2] overflow-hidden" style={{ boxShadow: "var(--mmm-shadow-sm)" }}>
        {loading ? <div className="p-4 space-y-3">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-10" />)}</div> :
          items.length === 0 ? <div className="p-10 text-center text-muted-foreground" data-testid="partner-referrals-empty">No referrals yet.</div> : (
          <div className="overflow-x-auto mmm-scroll">
            <Table data-testid="partner-referrals-table">
              <TableHeader><TableRow className="hover:bg-transparent">
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Family</TableHead>
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Type</TableHead>
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Sent</TableHead>
                <TableHead className="text-xs font-semibold text-[#1C4358]/80">Status</TableHead>
              </TableRow></TableHeader>
              <TableBody>
                {items.map((r) => (
                  <TableRow key={r.id} className="hover:bg-[rgba(155,185,206,0.10)]">
                    <TableCell className="py-3 font-medium text-[#252221]">{r.family_name || "—"}</TableCell>
                    <TableCell className="text-sm">{laneLabel(r.referral_type)}</TableCell>
                    <TableCell className="text-sm text-muted-foreground">{formatDate(r.sent_date)}</TableCell>
                    <TableCell><StatusBadge value={r.status} /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}
